import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {post, get} from "./http/http";
import {
    InfiniteScroll,
    Form,
    FormItem,
    Input,
    Button,
    Message,
    Tabs,
    TabPane,
    Tooltip,
    Image,
    Drawer,
    Loading,
    Radio,
    Link,
    Menu,
    MenuItem,
    Progress,
    Carousel,
    CarouselItem,
    RadioGroup,
    Dialog,
    Card,
    Descriptions,
    DescriptionsItem,
    Tag,
    Table,
    TableColumn,
    Pagination,
    Icon,
    Collapse,
    CollapseItem,
    Select,
    Option,
    DatePicker,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 全局引入 Vant
import Vant from 'vant'
import 'vant/lib/index.css' // 引入 Vant 样式

// 注册 Vant
Vue.use(Vant)
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = get;

Vue.prototype.$message = Message;

Vue.use(InfiniteScroll)
Vue.use(Tooltip)
Vue.use(Menu)
Vue.use(Link)
Vue.use(MenuItem)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Image)
Vue.use(Drawer)
Vue.use(Loading)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(Card)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Tag)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Icon)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)

// ========== 修正：Vue 2 对应的全局错误捕获（核心修改） ==========
// 1. Vue 2 全局错误处理器（屏蔽页面红屏，保留控制台报错）
Vue.config.errorHandler = (err, vm, info) => {
    // 不做额外页面渲染操作，仅捕获错误阻止红屏
    // err 会自动打印到控制台，满足你调试需求
    console.debug('Vue 2 全局捕获错误（页面已屏蔽展示）：', err, info)
}

// 2. 处理全局 Promise 未捕获异常（仅屏蔽页面影响，保留控制台报错）
window.addEventListener('unhandledrejection', (event) => {
    // 不写 event.preventDefault()，保留控制台原始报错
    const errorMsg = event.reason?.message || ''
    // 只针对你的视频目标错误做标记，不影响其他错误调试
    if (errorMsg.includes('The play() request was interrupted because video-only background media')) {
        console.debug('视频播放节能拦截（页面无影响）：', event.reason)
    }
    // 无需额外操作，页面不会展示错误提示，控制台正常报错
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
